module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0608-74286eca0021b27d3f4949528bd967ec.jpg";